import {
  SET_RELATIONSHIP_DATA,
  CHANGE_REFETCH_STATUS,
  RESET_RELATIONSHIP_DATA,
  APPEND_RELATIONSHIP_LANE_DATA,
} from './relationshipTypes';

export const setRelationshipData = (data, refetch) => {
  return {
    type: SET_RELATIONSHIP_DATA,
    payload: { data, refetch },
  };
};

export const setRelationshipLaneData = (laneId, data, refetch) => {
  return {
    type: APPEND_RELATIONSHIP_LANE_DATA,
    payload: { laneId, data, refetch },
  };
};

export const changeRefetchStatus = (status) => {
  return {
    type: CHANGE_REFETCH_STATUS,
    payload: status,
  };
};

export const resetRelationshipData = () => {
  return {
    type: RESET_RELATIONSHIP_DATA,
  };
};
